import React, {Component} from 'react';
import Cities from './cities';
import SiteMap from './sitemap';
import Link from 'gatsby-link'

import './footer.styl'

class Footer extends Component {
	static propTypes = {
		name: React.PropTypes.string,
	};

	constructor(props) {
		super(props);
	}

	render() {
		// console.log(this.props.footerData)
		return (
			<div>
				<div className="FooterWrapper">
		    		<div className="FooterContent ">
		    			{
		    				this.props.footerData.map( (item) => {
								// return <Cities title={item.title} key={item.id} /> // 
								// return <Cities {...item} key={item.id} /> // Spread Operator {...item}
								return <Cities {...item} key={item.id} /> // Spread Operator {...item}
		    				})
		    			}
		    			<SiteMap/>
		    		</div>
	    			<div className="FooterBtn">
	    				<a href="https://www.facebook.com/remagencia/" target="blank">Facebook</a>
	    				<a href="https://dribbble.com/remagencia" target="blank">Dribbble</a>
	    				<a href="https://www.instagram.com/remagencia/" >Instagram</a>
	    				<a href="https://www.youtube.com/channel/UCgrJg_4X9ZkoMaEKi2yjApQ" target="blank">Youtube</a>
					</div>
		    	</div>
		    	<div className='academy-badge'>
					<a href='https://hubspot-academy.s3.amazonaws.com/prod/tracks/user-certificates/22-5749215-1534726831431.png' title='Inbound'>
					<img src='https://hubspot-academy.s3.amazonaws.com/prod/tracks/user-badges/22-5749215-1534726831569.png' />
					</a>
				</div>
			</div>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js